export default __webpack_public_path__ + "static/media/DOCTORCERTIFICATE_A5_EN_BLANK.0c8ffba1.png";